import { useTranslation } from "react-i18next";

export default function IcoNotebook() {
	const { t } = useTranslation();

	return (
		<img
			src="/assets/images/ico-notebook.webp"
			alt={t("research_and_analysis_title")}
			loading="eager"
			width="225"
			height="200"
		/>
	);
}
